import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { partnerPortalLogin } from '../../config/partnerPortal';

const RoleBasedHome: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Signed up on the plans page but hasn't paid yet: finish checkout first.
  if (user.needs_plan) {
    return <Navigate to="/choose-plan" replace />;
  }

  switch (user.role) {
    case 'super_admin':
      return <Navigate to="/admin/corporates" replace />;
    case 'corporate_admin':
    case 'corporate_hr':
      return <Navigate to="/hr" replace />;
    case 'customer_service':
      return <Navigate to="/cs/dashboard" replace />;
    case 'management':
    case 'sales_team':
      // These roles belong on the management portal, not the main employee app.
      // Hard redirect away — the management portal is hosted at a different origin.
      if (typeof window !== 'undefined') {
        window.location.replace('https://management.infinicare.ai/');
      }
      return null;
    case 'channel_partner':
      // Channel partners work in their own portal, hosted at a different origin.
      if (typeof window !== 'undefined') {
        window.location.replace(partnerPortalLogin());
      }
      return null;
    case 'employee':
    default:
      return <Navigate to="/home" replace />;
  }
};

export default RoleBasedHome;
